import { getAreaStyle } from '../../theme/line';
import { isType } from '../../utils/util';
import merge from 'lodash.merge';
import cloneDeep from 'lodash.clonedeep';

var getLineTooltip = function getLineTooltip(config) {
  return {
    trigger: 'axis'
  };
};

var getLineYAxis = function getLineYAxis(config) {
  return {
    type: 'value'
  };
};

var getLineSeries = function getLineSeries(config, series) {
  series.forEach(function (chart) {
    if (!isType(chart, 'line')) return;
    chart.showSymbol = !!config.showSymbol;

    if (config.showArea) {
      chart.areaStyle = getAreaStyle();
    }
  });
  return series;
};

export default function (config) {
  if (config === void 0) {
    config = {};
  }

  return function (options) {
    var tooltip = getLineTooltip(config);
    var yAxis = getLineYAxis(config);
    var series = getLineSeries(config, cloneDeep(options.series));
    return merge({
      tooltip: tooltip,
      yAxis: yAxis,
      series: series
    }, options);
  };
}